import { makeObservable, observable } from 'mobx';
import { AbstractStore } from '../Abstract/AbstractStore';
import { FilterStore, ResultStore, MerchandisingStore, PaginationStore, SortingStore } from '../Search/Stores';
import { StorageStore } from '../Storage/StorageStore';
import { StateStore, TermStore, QueryStore, FacetStore, TrendingStore } from './Stores';
export class AutocompleteStore extends AbstractStore {
    constructor(config, services) {
        super(config);
        if (typeof services != 'object' || typeof services.urlManager?.subscribe != 'function') {
            throw new Error(`Invalid service 'urlManager' passed to AutocompleteStore. Missing "subscribe" function.`);
        }
        this.services = services;
        this.state = new StateStore(services);
        this.storage = new StorageStore();
        this.trending = [];
        this.reset();
        makeObservable(this, {
            state: observable,
            search: observable,
            terms: observable,
            facets: observable,
            filters: observable,
            merchandising: observable,
            results: observable,
            pagination: observable,
            sorting: observable,
        });
    }
    reset() {
        this.state.reset();
        this.update();
        this.resetTrending();
    }
    resetTrending() {
        if (this.trending?.length) {
            this.trending.forEach((term) => {
                term.active = false;
            });
        }
    }
    resetTerms() {
        this.terms?.forEach((term) => {
            term.active = false;
        });
    }
    setService(name, service) {
        if (this.services[name] && service) {
            this.services[name] = service;
            if (name === 'urlManager') {
                this.state.url = service;
            }
        }
    }
    updateTrendingTerms(data) {
        this.trending = new TrendingStore(this.services, data, () => {
            this.resetTerms();
        }, this.state);
    }
    update(data = {}) {
        if (!data)
            return;
        this.error = undefined;
        this.loaded = !!data.pagination;
        this.meta = data.meta || {};
        // set the query to match the actual queried term and not the input query
        if (data.search) {
            this.state.url = this.services.urlManager = this.services.urlManager.set('query', data.search.query);
        }
        // only run if we want to update the terms (not locked)
        if (!this.state.locks.terms.locked) {
            this.terms = new TermStore(this.services, data.autocomplete || {}, data.pagination || {}, () => {
                this.resetTrending();
            }, this.state);
            // only lock if there was data
            data.autocomplete && this.state.locks.terms.lock();
        }
        this.merchandising = new MerchandisingStore(this.services, data.merchandising || {});
        this.search = new QueryStore(this.services, data.autocomplete || {}, data.search || {});
        // only run if we want to update the facets (not locked)
        if (!this.state.locks.facets.locked) {
            this.facets = new FacetStore(this.config, this.services, this.storage, data.facets || [], data.pagination || {}, this.meta, this.state);
        }
        this.filters = new FilterStore(this.services, data.filters, this.meta);
        this.results = new ResultStore(this.config, this.services, data.results || [], data.pagination, data.merchandising);
        if ((this.results.length === 0 && !this.trending.filter((term) => term.active).length) || this.terms?.filter((term) => term.active).length) {
            // if a trending term was selected and then a subsequent search yields no results, reset trending terms to remove active state
            // OR if any terms are active, also reset to ensure only a single term or trending term is active
            this.resetTrending();
        }
        this.pagination = new PaginationStore(this.config, this.services, data.pagination);
        this.sorting = new SortingStore(this.services, data.sorting || [], data.search || {}, this.meta);
    }
}
